import {UntypedFormControl} from '@angular/forms';
import {Injectable} from '@angular/core';

export interface ValidationResult {
  [key: string]: boolean;
}
@Injectable({ providedIn: 'root' })
export class ArchiveValidator {
  constructor() {
  }

  static numericInput(control: UntypedFormControl): ValidationResult {
    const value = Number(control?.value);
    if (isNaN(value)) {
      return <ValidationResult>{'numeric': true};
    }
    return null;
  }
}
